import { Component, ElementRef, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@shared/component.dialog';
import { PickHourModal } from '../pick-hour-modal/pick-hour-modal';

@Component({
  selector: 'app-time-picker',
  standalone: true,
  imports: [],
  templateUrl: './time-picker.component.html',
  styleUrl: './time-picker.component.scss'
})
export class TimePickerComponent{
  @Output() timeSelected = new EventEmitter<{hour: string, minute: string, period: string}>();
  @Output() modalClosed = new EventEmitter<void>();
  @ViewChild('hoursContainer') hoursContainer!: ElementRef;
  @ViewChild('minutesContainer') minutesContainer!: ElementRef;
  @ViewChild('periodContainer') periodContainer!: ElementRef;

  selectedHour: string = '1';
  selectedMinute: string = '28';
  selectedPeriod: string = 'AM';

  constructor(
    @Inject(DIALOG_DATA) public data: PickHourModal,
    private readonly dialogRef: DialogRef
  ){}

  onHourScroll() {
    const CENTER_OFFSET = 2;
    const container = this.hoursContainer.nativeElement;
    const items = container.getElementsByClassName('time-item');
    const containerRect = container.getBoundingClientRect();
    const centerY = containerRect.top + containerRect.height / CENTER_OFFSET;

    let closestItem = null;
    let minDistance = Infinity;

    for (const item of items) {
      const rect = item.getBoundingClientRect();
      const distance = Math.abs(rect.top + rect.height / CENTER_OFFSET - centerY);
      if (distance < minDistance) {
        minDistance = distance;
        closestItem = item;
      }
    }

    if (closestItem) {
      this.selectedHour = closestItem.textContent?.trim() || '1';
    }
  }

  onMinuteScroll() {
    const CENTER_OFFSET = 2;
    const container = this.minutesContainer.nativeElement;
    const items = container.getElementsByClassName('time-item');
    const containerRect = container.getBoundingClientRect();
    const centerY = containerRect.top + containerRect.height / CENTER_OFFSET;

    let closestItem = null;
    let minDistance = Infinity;

    for (const item of items) {
      const rect = item.getBoundingClientRect();
      const distance = Math.abs(rect.top + rect.height / CENTER_OFFSET - centerY);
      if (distance < minDistance) {
        minDistance = distance;
        closestItem = item;
      }
    }

    if (closestItem) {
      this.selectedMinute = closestItem.textContent?.trim() || '00';
    }
  }

  onPeriodScroll() {
    const CENTER_OFFSET = 2;
    const container = this.periodContainer.nativeElement;
    const items = container.getElementsByClassName('time-item');
    const containerRect = container.getBoundingClientRect();
    const centerY = containerRect.top + containerRect.height / CENTER_OFFSET;

    let closestItem = null;
    let minDistance = Infinity;

    for (const item of items) {
      const rect = item.getBoundingClientRect();
      const distance = Math.abs(rect.top + rect.height / CENTER_OFFSET - centerY);
      if (distance < minDistance) {
        minDistance = distance;
        closestItem = item;
      }
    }

    if (closestItem) {
      this.selectedPeriod = closestItem.textContent?.trim() || 'AM';
    }
  }

  selectTime() {
    this.timeSelected.emit({
      hour: this.selectedHour,
      minute: this.selectedMinute,
      period: this.selectedPeriod
    });
    this.closeModal();
  }

  closeModal() {
    this.modalClosed.emit();
    this.dialogRef.close();
  }
}
